const CardWithLoader = require("../Dashboard/card-with-loader");
var Icon = require("app/shared/components/Icon/icon");
const Summary = require("../Dashboard/summary");
var UserAvatar = require("app/shared/components/User/user-avatar");
const Tooltip = require("app/shared/components/Tooltip/tooltip");
var config = require("app/util/config/config");

var _ = require("underscore");

const Reflux = require("reflux");
const ScheduledTasksStore = require("../../stores/scheduled-tasks-store");
const ScheduledTasksActions = require("../../actions/scheduled-tasks-actions");

const ScheduledTasksWidget = React.createClass({
  mixins: [Reflux.ListenerMixin],
  typeMap: {
    visit: {
      key: "visit",
      icon: "visit",
      label: "Visita"
    },
    meeting: {
      key: "meeting",
      icon: "meeting",
      label: "Reunião"
    },
    proposal: {
      key: "proposal",
      icon: "proposal",
      label: "Proposta"
    },
    call: {
      key: "call",
      icon: "call",
      label: "Ligação"
    },
    whatsapp: {
      key: "whatsapp",
      icon: "whatsapp",
      label: "WhatsApp"
    },
    email: {
      key: "email",
      icon: "email",
      label: "E-mail"
    },
    no_type: {
      key: "no_type",
      icon: "task",
      label: "Sem tipo"
    }
  },

  getInitialState: function() {
    return ScheduledTasksStore.getInitialState();
  },

  componentDidMount: function() {
    this.listenTo(ScheduledTasksStore, this.setState);
    this.refresh();
  },

  componentDidUpdate: function(prevProps) {
    if (prevProps != this.props) {
      this.refresh();
    }
  },

  refresh: function() {
    ScheduledTasksActions.fetchData(
      this.props.period,
      this.props.users
    );
  },

  userRows: function() {
    var ranking = _.map(this.state.data, function(user) {
      if (user) {
        return this.userRow(user);
      }
    }.bind(this));

    return ranking;
  },
  userRow: function(data) {
    var userData = {
      id: data.user.id,
      name: data.user.name,
      activities: data.activities
    };

    var types = _.values(this.typeMap);

    var userDataCells = _.map(types, function(type, i) {
      return <UserData
        key={i}
        id={userData.id}
        name={userData.name}
        data={userData.activities[type.key]}
        period={this.props.period}
        type={type.label}
        typeKey={type.key}
      />;
      }.bind(this));

      return <tr scope="row" className="h-60" key={userData.id}>
      <UserAvatarCell id={userData.id} name={userData.name} />
      {userDataCells}
      <UserData
        id={userData.id}
        name={userData.name}
        data={data.total}
        period={this.props.period}
        type={"total"}
      />
    </tr>;
  },

  emptyList: function() {
    return <tr>
      <td colSpan={4}>
        <span className="fs-14 c-lightGrey">
          Não há informações de negócios vendidos para o período selecionado
        </span>
      </td>
    </tr>;
  },

  render: function() {
    return (
      <CardWithLoader
        loading={this.state.loading}
        failed={this.state.failed}
        onRetry={this.refresh}
        title={
          <p>Atividades finalizadas/agendadas</p>
        }
        className="grid-item-col-3"
        footer={
          <span className="text-muted">
            Clique nos valores para ver a lista de tarefas
          </span>
        }
      >
        <div className="h-280 ovy-auto thinScrollbar ta-c p-r">
          <table className='table table-striped w-100pct c-black mb-0'>
            <thead>
              <ScheduledTasksHeader
                columns={this.typeMap} />
            </thead>
            <tbody>
              {this.userRows()}
            </tbody>
          </table>
        </div>
      </CardWithLoader>
    )
  }
});

const ScheduledTasksHeader = React.createClass({
  buildHeader: function() {
    var columns = _.map(this.props.columns, function(headerCell, i) {
      return this.headerize(headerCell, i+1);
    }.bind(this));

    var usersColumn = this.headerize({label: "usuário"}, 0);
    var totalColumn = this.headerize(
      {label: "total"},
      this.props.columns.length + 1
    );

    var headersColumns = [usersColumn].concat(columns).concat(totalColumn)

    return headersColumns;
  },

  headerize: function(headerObject, key) {
    var headerIcon = "";
    var headerLabel;
    if (headerObject.icon) {
      var iconClass = headerObject.icon;

      if (headerObject.icon != "email") {
        var sizeClass = "fs-20"
      }

      headerIcon = <Icon custom icon={iconClass} className={`self-center mb-5 ${sizeClass}`}/>;
      headerLabel = headerObject.label
    } else {
      headerLabel = headerObject.label;
    }

    return <th scope="col" className="bb-n th-fixed bg-white" key={key}>
      <div className="d-f flex-column">
        {headerIcon}
        <span className="fw-500 d-b ta-c fs-11 tt-upper">{headerLabel}</span>
      </div>
    </th>
  },

  render: function () {
    return <tr>{this.buildHeader()}</tr>;
  }
});

const UserAvatarCell = React.createClass({
  render: function() {
    return (
      <td className="ta-c">
        <UserAvatar
          name={this.props.name}
          size="small"
          avatarURL={`${config.app.apiRailsURL}/users/${this.props.id}/avatar`} />
        <span className="d-b fs-11">{this.props.name}</span>
      </td>
    );
  }
});

const UserData = React.createClass({
  cellWidth: 55,

  getDetailsUrl: function(id, scheduled) {
    if (scheduled === 0) {
      return null;
    }

    let dateFormat = "YYYY-MM-DD";
    let formattedStartDate = this.props.period.startDate.format(dateFormat);
    let formattedEndDate = this.props.period.endDate.format(dateFormat);
    let metricParam = "";

    let searchParams = new URLSearchParams();

    searchParams.append("pending", false);
    searchParams.append("dateRange", "CUSTOM");
    searchParams.append("dtInicial", formattedStartDate);
    searchParams.append("dtFinal", formattedEndDate);
    searchParams.append("userId", this.props.id);

    if(this.props.typeKey) {
      searchParams.append("typeName", this.props.typeKey);
    }

    // Added metrics_ids manually because otherwise the brackets were escaped
    // and the filtering did not work.
    if (id) {
      metricParam = `&metric_ids=[${id}]`;
    }

    return `/sistema/tarefas?${searchParams}${metricParam}`;
  },

  tooltipForUser: function(name, scheduled, done, type) {
    if (type) {
      type = type.toLowerCase();
    } else {
      type = "total";
    }

    return `<b>${name}</b>\n\nFinalizou <b>${done}</b> das <b>${scheduled}</b> tarefas do tipo ${type} que foram agendadas para o período selecionado.`;
  },

  ratioSpan: function(ratio = 0) {
    if (this.props.type == 'total') {
      return <span
        className="p-a fw-bold fs-11"
        style={{"top": 20, "left": 0, "width": this.cellWidth}}>
        {`(${(ratio*100).toFixed(1)}%)`}
      </span>;
    }
  },

  userCellLinkProps: function({ id, scheduled }) {
    let props = { className: "seamless-link" };
    const detailsUrl = this.getDetailsUrl(id, scheduled);

    if (detailsUrl) {
      props.target = "_blank";
      props.href = detailsUrl;
    }

    return (props)
  },

  userCell: function() {
    var typeData = Object.assign(
      {"scheduled": 0, "done": 0},
      this.props.data
    );

    var textColorModifier = "";
    if (typeData.scheduled > typeData.done) {
      textColorModifier = "c-primaryRed";
    }

    return (
      <a { ...this.userCellLinkProps(typeData) }>
        <Tooltip container="body" color="darker" html bottom
          title={this.tooltipForUser(
            this.props.name,
            typeData.scheduled,
            typeData.done,
            this.props.type)}>
            <div className="mt-5 p-r" style={{"width": this.cellWidth}}>
              <span className={`fs-14 f-l ${textColorModifier}`} style={{"margin-left": 10}}>
                {typeData.done}
              </span>
              <span className="fs-14 p-a" style={{"top": 4, "transform": "rotate(40deg)", "marginLeft": "-10px"}}>
                |
              </span>
              <span className="fs-12 p-a" style={{"top": 8, "left": 40}}>
                {typeData.scheduled}
              </span>
              {this.ratioSpan(typeData.ratio)}
            </div>
          </Tooltip>
        </a>
      );
  },

  render: function() {
    return <td className="c-lightGrey" key={this.props.key}>
      {this.userCell()}
    </td>;
  }
});

module.exports = ScheduledTasksWidget;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/components/Widgets/scheduled-tasks.jsx